import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField/index';
import Dialog from '@material-ui/core/Dialog/index';
import DialogActions from '@material-ui/core/DialogActions/index';
import DialogContent from '@material-ui/core/DialogContent/index';
import DialogTitle from '@material-ui/core/DialogTitle/index';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import FormGroup from "@material-ui/core/FormGroup";
import Grid from "@material-ui/core/Grid";

import Divider from "@material-ui/core/Divider";
import DraggableModal from "../../../../Include/DraggableModal/DraggableModal";
import {FieldsJs} from "../../../../../settings/General/General";
import Slide from "@material-ui/core/Slide";
import {MenuEspecificoService} from "../../../../../services/_Cat/MenuEspecificoService/MenuEspecificoService";
import {
	BotonAccionAbrirModal,
	BotonAccionFooterModal,
	TituloHeaderModal
} from "../../../../Include/MiniComponents/GlobalComponent";
import {TicketsService} from "../../../../../services/TicketsService/TicketsService";
import {CatService} from "../../../../../services/_Cat/CatService/CatService";
import {Group} from "@material-ui/icons";
import Typography from "@material-ui/core/Typography";
import {CONFIG} from "../../../../../settings/Config/Config";

class ModalMenuEspecifico extends Component {
	
	state = {};
	
	constructor(props) {
		super(props);
		
		this.state = {
			modal: {
				open: false
			},
			
			tipo: props.tipo,
			
			id_acceso_menu_especifico: (props.item || '').id_acceso_menu_especifico,
			id_usuario: '',
			id_cat_tipo_usuario: '',
			tipo_usuario: '',
			id_menu: '',
			todas_empresas: false,
			
			listar_usuarios: [],
			listar_menu: [],
			listar_empresas: [],
			empresas_seleccionadas: [],
			activo: true,
		};
	}
	
	handleChange = (e, variable, campo, date, input) => {
		FieldsJs.HandleChange(e, variable, campo, date, input, (r) => this.setState({
			[r.name]: r.value
		}));
	};
	
	changeValue = (arr_name__key, var_name, var_value) => {
		FieldsJs.ChangeValue(arr_name__key, var_name, var_value, (r) => this.setState({
			[r.name]: r.value
		}), this.state);
	};
	
	closeModal = () => {
		this.setState({
			modal: {
				open: false
			}
		});
	};
	
	close = () => {
		this.closeModal();
	};
	
	openModal = () => {
		const props = this.props;
		this.setState({
			modal: {
				open: true
			}
		});
	};
	
	open = () => {
		this.init().then(r => {
			setTimeout(() => this.openModal());
		}).catch(e => {
		});
	};
	
	RefreshInit = () => {
		this.init();
	};
	
	init = () => {
		return new Promise((resolve) => {
			resolve(true);
		});
	};
	
	selectUser = (id_usuario) => {
		var usuarios = FieldsJs.Copy(this.state.listar_usuarios);
		for (let i = 0; i < usuarios.length; i++) {
			if (Number(usuarios[i].id_usuario) === Number(id_usuario)) {
				this.setState({
					id_cat_tipo_usuario: usuarios[i].id_cat_tipo_usuario,
					tipo_usuario: usuarios[i].tipo_usuario
				});
			}
		}
	};
	
	listarUsuarios = () => {
		return new Promise((resolve, reject) => {
			CatService.ListUsuario().then((response) => {
				this.setState({
					listar_usuarios: response.data
				});
				resolve(response.data);
			}).catch((error) => {
				reject(error);
				this.props.showSnackBars('error', error.mensaje);
			});
		});
	};
	
	listarMenu = () => {
		return new Promise((resolve, reject) => {
			CatService.ListMenu().then((response) => {
				this.setState({
					listar_menu: response.data
				});
				resolve(response.data);
			}).catch((error) => {
				reject(error);
				this.props.showSnackBars('error', error.mensaje);
			});
		});
	};
	
	listarEmpresas = () => {
		return new Promise((resolve, reject) => {
			CatService.ListEmpresa().then((response) => {
				for (let i = 0; i < response.data.length; i++) {
					response.data[i].check = false;
				}
				this.setState({
					listar_empresas: response.data
				});
				resolve(response.data);
			}).catch((error) => {
				reject(error);
				this.props.showSnackBars('error', error.mensaje);
			});
		});
	};
	
	save = () => {
		if (this.state.id_acceso_menu_especifico > 0) {
			MenuEspecificoService.Modificar(this.state).then((response) => {
				this.close();
				this.props.RefreshList();
				this.props.showSnackBars('success', response.mensaje);
			}).catch((error) => {
				this.props.showSnackBars('error', error.mensaje);
			});
		} else {
			MenuEspecificoService.Agregar(this.state).then((response) => {
				this.close();
				this.props.RefreshList(response.data);
				this.props.showSnackBars('success', response.mensaje);
			}).catch((error) => {
				this.props.showSnackBars('error', error.mensaje);
			});
		}
	};
	
	add = () => {
		this.listarUsuarios();
		this.listarMenu();
		this.listarEmpresas();
		this.setState({
			id_acceso_menu_especifico: '',
			id_usuario: '',
			id_cat_tipo_usuario: '',
			tipo_usuario: '',
			id_menu: '',
			activo: true,
			empresas_seleccionadas: []
		});
		this.open();
	};
	
	edit = () => {
		const {item} = this.props;
		
		this.listarEmpresas().then((e) => {
			if (item.empresas_seleccionadas.length > 0) {
				for (let i = 0; i < item.empresas_seleccionadas.length; i++) {
					this.asignarUsuarioReporte(item.empresas_seleccionadas[i]);
				}
			}
		});
		this.listarUsuarios().then((response) => {
			this.setState({
				id_usuario: item.id_usuario || '',
			});
		});
		this.listarMenu().then((response) => {
			this.setState({
				id_menu: item.id_menu || '',
			});
		});
		this.setState({
			id_acceso_menu_especifico: item.id_acceso_menu_especifico || '',
			id_cat_tipo_usuario: item.id_cat_tipo_usuario || '',
			tipo_usuario: item.tipo_usuario || '',
			id_menu: item.id_menu || '',
			activo: (item.activo === 1),
			empresas_seleccionadas: []
		});
		
		this.open();
	};
	
	view = () => {
		const {item} = this.props;
		
		this.listarEmpresas().then((e) => {
			if (item.empresas_seleccionadas.length > 0) {
				for (let i = 0; i < item.empresas_seleccionadas.length; i++) {
					this.asignarUsuarioReporte(item.empresas_seleccionadas[i]);
				}
			}
		});
		this.listarUsuarios().then((response) => {
			this.setState({
				id_usuario: item.id_usuario || '',
			});
		});
		this.listarMenu().then((response) => {
			this.setState({
				id_menu: item.id_menu || '',
			});
		});
		this.setState({
			id_acceso_menu_especifico: item.id_acceso_menu_especifico || '',
			id_cat_tipo_usuario: item.id_cat_tipo_usuario || '',
			tipo_usuario: item.tipo_usuario || '',
			id_menu: item.id_menu || '',
			activo: (item.activo === 1),
			empresas_seleccionadas: []
		});
		
		this.open();
	};
	
	handleChangeEmpresas = (todas_empresas) => {
		let te = !this.state.todas_empresas;
		
		for (let i = 0; i < this.state.listar_empresas.length; i++) {
			this.state.listar_empresas[i].check = te;
		}
		
		this.setState({
			empresas_seleccionadas: te ? this.state.listar_empresas:[]
		});
	}
	
	asignarUsuarioReporte = (id_empresa, id_empresa_autorizado) => {
		let empresas = FieldsJs.Copy(this.state.listar_empresas);
		let users = FieldsJs.Copy(this.state.empresas_seleccionadas);
		let banduser = false;
		let userkey = 0;
		for (let i = 0; i < users.length; i++) {
			if (Number(users[i].id_empresa) === Number(id_empresa)) {
				banduser = true;
				userkey = i;
			}
		}
		if (!banduser) {
			for (let i = 0; i < empresas.length; i++) {
				if (Number(empresas[i].id_empresa) === Number(id_empresa)) {
					empresas[i].check = true;
					if (id_empresa_autorizado) {
						empresas[i].id_empresa = id_empresa_autorizado;
					}
					users.push(empresas[i]);
				}
			}
		} else {
			for (let i = 0; i < empresas.length; i++) {
				if (Number(empresas[i].id_empresa) === Number(id_empresa)) {
					empresas[i].check = false;
				}
			}
			users.splice(userkey, 1);
		}
		this.setState({
			listar_empresas: empresas,
			empresas_seleccionadas: users,
		}, () => {
			console.log(this.state.empresas_seleccionadas);
		});
	};
	
	render() {
		
		let funcion;
		
		switch (this.state.tipo) {
			case 'edit':
				funcion = this.edit;
				break;
			case 'add':
				funcion = this.add;
				break;
			case 'view':
				funcion = this.view;
				break;
			default:
				funcion = () => {
				};
		}
		
		let le = this.state.listar_empresas;
		
		return (
			<div>
				
				{this.props.componente ? (
					<Fragment>
						<span
							style={{cursor: 'pointer'}}
							children={this.props.componente}
							onClick={() => funcion()}
						/>
					</Fragment>
				) : (
					<BotonAccionAbrirModal
						id={this.state.id_acceso_menu_especifico}
						tipo={this.state.tipo}
						onClick={() => funcion()}
					/>
				)}
				
				<Dialog open={this.state.modal.open} onClose={() => this.close()} PaperComponent={DraggableModal}
				        disableEscapeKeyDown disableBackdropClick maxWidth={'sm'} fullWidth={true} scroll={'paper'}
				        transition={<Slide direction="up"/>} aria-labelledby="scroll-dialog-title"
				>
					
					<DialogTitle>
						<TituloHeaderModal
							tipo={this.state.tipo}
							titulo={'Menu Especifico'}
						/>
					</DialogTitle>
					
					<DialogContent>
						
						<Grid container spacing={1}>
							
							<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
								<TextField
									select
									fullWidth
									required
									margin="none"
									onChange={(e) => {
										this.handleChange(e);
										this.selectUser(e.target.value);
									}}
									disabled={this.state.tipo === 'view'}
									SelectProps={{
										native: true,
										MenuProps: {
											className: '',
										},
									}}
									name="id_usuario"
									label="Usuario"
									value={this.state.id_usuario}
								>
									<option key={0} value={''}>&nbsp;</option>
									{this.state.listar_usuarios.map(option => (
										<option key={option.id_usuario} value={option.id_usuario}>
											{option.correo_electronico + ' - ' + option.nombre_completo}
										</option>
									))}
								</TextField>
							</Grid>
							
							<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
								
								<TextField
									autoFocus
									margin="dense"
									name="tipo_usuario"
									label="Tipo Usuario"
									type="text"
									fullWidth
									value={this.state.tipo_usuario}
									onChange={this.handleChange}
									disabled={true}
								/>
							
							</Grid>
							
							<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
								<TextField
									select
									fullWidth
									required
									margin="none"
									onChange={this.handleChange}
									disabled={this.state.tipo === 'view'}
									SelectProps={{
										native: true,
										MenuProps: {
											className: '',
										},
									}}
									name="id_menu"
									label="Menú / Módulo"
									value={this.state.id_menu}
								>
									<option key={0} value={''}>&nbsp;</option>
									{this.state.listar_menu.map(option => (
										<option key={option.id_menu} value={option.id_menu}>
											{option.menu}
										</option>
									))}
								</TextField>
							</Grid>
							
							{Number(this.state.id_menu) === 26 ? (
								<Grid item className={'text-left borde-punteado-lightgray-2'} xs={12} sm={12} md={12} lg={12} xl={12}>
									<Grid container spacing={1} alignItems={"flex-center"}>
										<Grid className={'w-100'}>
											<FormGroup row className={'text-center check-recuser margin-15-L'}>
												<FormControlLabel
													control={
														<Checkbox
															type="checkbox"
															color="primary"
															name="todas_empresas"
															value={this.state.todas_empresas}
															onChange={(e) => {
																this.handleChange(e);
																this.handleChangeEmpresas(e.target.value)
															}}
															disabled={this.props.tipo === 'view'}
														/>
													}
													label={'Todas las empresas'}
												/>
											</FormGroup>
										</Grid>
										<Grid className={'w-100'}>
											<div style={{maxHeight: 280, overflowY: 'auto'}}>
												{this.state.listar_empresas.map((item, index) => (
													<Fragment key={index}>
														<div className={'vertical-inline w-95 cursor-pointer'} onClick={() => {
															if (this.props.tipo !== 'view') {
																this.asignarUsuarioReporte(item.id_empresa);
															}
														}}>
															<div className='v-center padding-10-L'>
																
																	<FormControlLabel
																		key={index}
																		control={
																			<Checkbox
																				type="checkbox"
																				color="primary"
																				checked={item.check}
																				disabled={this.props.tipo === 'view'}
																				name={'chek_'+index}
																				value={'chek_'+index}
																				defaultChecked={false}
																			/>
																		}
																		label={''}
																	/>
															</div>
															
															<div className={'v-center vertical-inline'}>
																<div className={'v-center w-30-px h-30-px b-r-100 bg-img-contain-x-center-y-center'}
																     style={{backgroundImage: `url(${item.logo ? CONFIG.src + item.logo : CONFIG.logo_default})`}}>
																</div>
																<Typography variant={'h5'} className={'v-center padding-15-L margin-0 text-black px-13'}>
																	{item.razon_social}
																</Typography>
															</div>
														</div>
													</Fragment>
												))}
											</div>
										</Grid>
									</Grid>
								</Grid>
							):null}
							
							
							<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
								
								<FormGroup row className={'margin-3-L'}>
									<FormControlLabel
										control={
											<Checkbox
												type="checkbox"
												disabled={this.state.tipo === 'view'}
												onChange={this.handleChange}
												color="primary"
												name='activo'
												checked={this.state.activo}
												value="activo"
											/>
										}
										label={'Activo'}
									/>
								</FormGroup>
							
							</Grid>
						
						</Grid>
					
					</DialogContent>
					
					<Divider/>
					
					<DialogActions>
						
						<BotonAccionFooterModal
							id={this.state.id_acceso_menu_especifico}
							tipo={this.state.tipo}
							close={this.close}
							save={this.save}
						/>
					
					</DialogActions>
				
				</Dialog>
			
			</div>
		);
	}
}

ModalMenuEspecifico.propTypes = {
	componente: PropTypes.element,
	tipo: PropTypes.string.isRequired,
	item: PropTypes.object.isRequired,
	RefreshList: PropTypes.func.isRequired,
	showSnackBars: PropTypes.func.isRequired,
};

export default ModalMenuEspecifico;
